import { render } from "./App.vue?vue&type=template&id=d41867e0"
const script = {}

import exportComponent from "/Users/husan/Realsoft/Platon/dbc/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__